import {
  Box,
  Fade,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Popover,
  useTheme,
  Divider,
  Typography,
  Tooltip,
} from '@mui/material';
import { FC, MouseEvent, ReactNode, useState } from 'react';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { FileUpload, IUploadFileToS3Return } from '../fileUpload/fileUpload.component';

export const OptionalMenu: FC<IOptionalMenuProps> = ({ menuItems, minWidthMenu = 214, title }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const theme = useTheme();
  const activeColor = theme.palette.action.hover;
  const open = Boolean(anchorEl);
  const handleClick = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <>
      <IconButton
        sx={{
          backgroundColor: open ? activeColor : 'inherit',
        }}
        onClick={handleClick}
      >
        <MoreVertIcon sx={{ fill: 'rgba(0, 0, 0, 0.54)' }} />
      </IconButton>
      <Popover
        anchorEl={anchorEl}
        open={open}
        keepMounted
        onClose={handleClose}
        TransitionComponent={Fade}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        sx={{
          marginTop: 1,
        }}
      >
        <Box
          sx={{
            minWidth: `${minWidthMenu}px`,
          }}
        >
          {title && (
            <>
              <Typography
                component='h5'
                sx={{
                  px: 2,
                  py: 1,
                }}
              >
                {title}
              </Typography>
              <Divider />
            </>
          )}
          <List sx={{ color: 'red', backgroundColor: 'red' }} disablePadding>
            {menuItems
              ?.filter(({ visible = true }) => visible)
              ?.map(
                ({
                  label,
                  icon,
                  onClick,
                  disabled,
                  isUpload,
                  onLoading,
                  onUploaded,
                  place,
                  accept,
                  color,
                  tooltip,
                }) => {
                  const listItem = (
                    <ListItem
                      key={label}
                      sx={{ ...(color && { color: `${color} !important` }) }}
                      disablePadding
                      onClick={() => {
                        !disabled && onClick();
                        handleClose();
                      }}
                    >
                      {isUpload && place ? (
                        <FileUpload.ListItemButton
                          {...{
                            disabled: !!disabled,
                            text: label,
                            place: place,
                            onLoading: onLoading,
                            onUploaded: onUploaded,
                            icon: icon,
                            accept: accept,
                          }}
                        >
                          <ListItemIcon
                            sx={{ minWidth: 40, ...(color && { color: `${color} !important` }) }}
                          >
                            {icon}
                          </ListItemIcon>
                          <ListItemText primary={label} />
                        </FileUpload.ListItemButton>
                      ) : (
                        <ListItemButton {...(disabled && { disabled })}>
                          <ListItemIcon
                            sx={{ minWidth: 40, ...(color && { color: `${color} !important` }) }}
                          >
                            {icon}
                          </ListItemIcon>
                          <ListItemText primary={label} />
                        </ListItemButton>
                      )}
                    </ListItem>
                  );

                  return tooltip ? (
                    <Tooltip key={label} title={tooltip} placement='left' enterDelay={1000}>
                      {listItem}
                    </Tooltip>
                  ) : (
                    listItem
                  );
                },
              )}
          </List>
        </Box>
      </Popover>
    </>
  );
};

interface IOptionalMenuProps {
  menuItems: IMenuItem[];
  minWidthMenu?: number;
  visibleBadge?: boolean;
  title?: string;
}

export interface IMenuItem {
  label: string;
  icon: ReactNode;
  onClick: () => void;
  disabled?: boolean;
  isUpload?: boolean;
  place?: string;
  onLoading?: () => void;
  onUploaded?: (result: IUploadFileToS3Return) => void;
  accept?: string;
  color?: string;
  tooltip?: string;
  visible?: boolean;
}
